/**
 * Update Component Fill
 *
 * @param component_name Component Name
 * @param component Component
 * @param options Options
 */
function updateComponentFill(component_name, component, options) {
  try {
    const patternID = `${component_name}_image`;
    const patternElement = this.svg.findOne(`#${patternID}`);
    if (patternElement) patternElement.remove();
    this.svg.findOne(`#${component_name}`).fill(component.toolkit_options.hex);
  } catch (err) {
    throw new Error('Error updating fill for ' + component_name);
  }
}

module.exports = updateComponentFill;
